import React from 'react';
import styles from "./DesktopPane.module.scss";
import cn from 'classnames';
import { Typography } from 'seagull';
import { Stepper } from "../Stepper";
import { InfoFooter } from "../../InfoFooter";
import { relationshipModel } from "../../../../models";
export const DesktopPane = _ref => {
  let {
    vendorDetails,
    showLearnMoreModal,
    stepperSteps,
    activeStepIndex,
    onStepClick,
    isPreview,
    completedSteps,
    activeSteps,
    'data-testid': testid
  } = _ref;
  const vendorLogoUrl = relationshipModel.vendorLogoUrl({
    vendor: vendorDetails
  });
  return /*#__PURE__*/React.createElement("aside", {
    className: cn(styles.root),
    "data-testid": testid
  }, /*#__PURE__*/React.createElement("div", {
    className: styles.stepper
  }, vendorLogoUrl ? /*#__PURE__*/React.createElement("div", {
    className: styles.logoImg,
    style: {
      backgroundImage: "url(".concat(vendorLogoUrl, ")")
    }
  }) : /*#__PURE__*/React.createElement(Typography, {
    variant: "h5",
    className: styles.logoTxt
  }, vendorDetails.name), /*#__PURE__*/React.createElement(Stepper, {
    steps: stepperSteps,
    completedSteps: completedSteps || [],
    activeStepIndex: activeStepIndex,
    onStepClick: onStepClick,
    "data-testid": testid && testid + '-stepper',
    isPreview: isPreview,
    activeSteps: activeSteps || []
  })), /*#__PURE__*/React.createElement(InfoFooter, {
    vendorDetails: vendorDetails,
    showLearnMoreModal: showLearnMoreModal,
    "data-testid": testid
  }));
};